
import Member from './member';

export default  Member
